<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4 class="font-weight-bold">{{ setting.name }}</h4>
      </div>
      <div class="col-6">
        <p class="m-0">{{ setting.company_name }}</p>
      </div>
      <div class="col-6 text-right">
        <p class="m-0">Invoice</p>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-6">
        <div v-show="is_loading">
          <skeleton-box
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
        </div>
        <div v-show="!is_loading">
          <p class="m-0 font-weight-bold">Invoice To</p>
          <p class="m-0">{{ user.name }}</p>
          <p class="m-0">{{ user.phone_number }}</p>
          <p class="m-0">{{ user.email }}</p>
        </div>
      </div>
      <div class="col-6">
        <div v-show="is_loading">
          <skeleton-box
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
        </div>
        <div v-show="!is_loading">
          <p class="m-0 font-weight-bold">Invoice Information</p>
          <p class="m-0">No: {{ invoice.id }}</p>
          <p class="m-0">Issued Date: {{ invoice.date.format('DD MMMM YYYY') }}</p>
          <p class="m-0">Status: {{ invoice.status }}</p>
          <p class="m-0">Payment Method: {{ invoice.payment_method.name }}</p>
        </div>
      </div>
      <div class="col-12">
        <div v-show="is_loading" class="row mt-3">
          <div class="col-12 col-lg-4">
            <skeleton-box
              height="30px"
              width="100%"/>
          </div>
          <div class="col-12 col-lg-4">
            <skeleton-box
              height="30px"
              width="100%"/>
          </div>
          <div class="col-12 col-lg-4">
            <skeleton-box
              height="30px"
              width="100%"/>
          </div>
        </div>
        <div v-show="!is_loading">
          <table class="table table-bordered" v-if="type != 'Panggilan'">
            <thead>
              <tr>
                <th>#</th>
                <th>Info</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{{ type }}</td>
                <td class="text-right">Rp. {{ invoice.price.toLocaleString('id-ID') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="text-center">Sub-Total</td>
                <td class="text-right">Rp. {{ (invoice.price).toLocaleString('id-ID') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="text-center">Discount</td>
                <td class="text-right">Rp. {{ invoice.discount.toLocaleString('id-ID') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="text-center">Pajak</td>
                <td class="text-right">Rp. {{ invoice.tax.toLocaleString('id-ID') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="text-center">Total</td>
                <td class="text-right">Rp. {{ invoice.grand_total.toLocaleString('id-ID') }}</td>
              </tr>
            </tbody>
          </table>
          <call-detail v-else
            :arr_detail="arr_detail"
            :invoice="invoice"/>
        </div>
      </div>
    </div>
    <div class="row" v-show="!is_loading">
      <div class="col-12 text-right">
        <a href="#!" class="btn btn-primary">Print</a>
        <a href="#!" @click="download" class="btn btn-primary">Download</a>
        <button class="btn btn-primary" v-if="invoice.xendit_status != 'PAID' && invoice.xendit_status != 'Canceled'" v-on:click="bypass_payment">Bypass Payment</button>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBox from '@/layout/skeleton'
import CallDetail from '@/pages/order/table_detail'

export default{
  components:{
    'skeleton-box': SkeletonBox,
    'call-detail': CallDetail,
  },
  data(){
    return{
      invoice: {
        id: 'INV/0001',
        date: moment('2020-03-03'),
        price: 10000,
        total_price: 0,
        status: 'belum bayar',
        tax: 0,
        payment_method: {
          name: ''
        },
      },
      user: {
        name: 'test',
        email: 'test@test.com',
        phone_number: '121221',
      },
      is_loading: true,
      type: '',
      arr_detail: [],
      setting: {
        name: '',
        company_name: '',
      },
    }
  },
  async created(){
    if(this.$route.query.id.search("INVT") != -1)
      this.type = 'Rekrut'
    else if(this.$route.query.id.search("INVR") != -1)
      this.type = 'Pendaftaran'
    else if(this.$route.query.id.search("INVF") != -1)
      this.type = 'Verifikasi'
    else if(this.$route.query.id.search("INVP") != -1)
      this.type = 'Top up point'
    else if(this.$route.query.id.search("INVC") != -1)
      this.type = 'Panggilan'

    await this.get_data()
    await this.get_setting()
    this.is_loading = false
  },
  methods:{
    async get_data(){
      try{
        var response
        if(this.type == 'Rekrut')
          response = await axios.get(base_url+'/order-interested?id='+this.$route.query.id)
        else if(this.type == 'Pendaftaran')
          response = await axios.get(base_url+'/order-register?id='+this.$route.query.id)
        else if(this.type == 'Verifikasi')
          response = await axios.get(base_url+'/order-verify?id='+this.$route.query.id)
        else if(this.type == 'Top up point')
          response = await axios.get(base_url+'/order-point?id='+this.$route.query.id)
        else if(this.type == 'Panggilan')
          response = await axios.get(base_url+'/order-call?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          if(this.type != 'Panggilan'){
            this.invoice = response_data.data
            this.invoice.id = response_data.data.id
            this.invoice.date = moment(response_data.data.created_at)
            this.invoice.price = parseFloat(response_data.data.total_price != null ? response_data.data.total_price : response_data.data.price)
            this.invoice.tax = parseFloat(response_data.data.tax == null ? 0 : response_data.data.tax)
            // this.type = response_data.data['tipe invoice']
            this.invoice.payment_method = response_data.data.payment_method
            this.invoice.status = response_data.data.status != null ? response_data.data.status : (response_data.data.file_name == null ? 'belum bayar' : 'sudah bayar')
            this.user = this.type == 'Top up point' ? response_data.data.point.user : response_data.data.user
          }
          else{
            this.invoice = response_data.data
            this.invoice.date = moment(this.invoice.date)
            this.arr_detail = response_data.data.detail

            var sub_total = 0
            for(let x in this.arr_detail){
              var name = ''
              if(this.arr_detail[x].helper_sub_sub_category != null){
                name += this.arr_detail[x].helper_sub_sub_category.helper_sub_category.name + " " + this.arr_detail[x].helper_sub_sub_category.name
              }
              else if(this.arr_detail[x].helper_sub_category != null){
                name += this.arr_detail[x].helper_sub_category.name
              }
              this.arr_detail[x].name = name
              sub_total += this.arr_detail[x].amount * this.arr_detail[x].price
            }
            this.invoice.sub_total = sub_total
          }
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async get_setting(){
      try{
        var response = await axios.get(base_url+'/setting')

        var response_data = response.data
        if(response_data.status == "success"){
          this.setting = response_data.data
          // console.log(moment(response_data.data.publish_date).format('DD/MM/YYYY'))
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    async bypass_payment(){
      try{
        var data = {}
        data.id = this.invoice.id

        var response = await axios.put(base_url+'/order/payment',data)

        var response_data = response.data
        if(response_data.status == "success"){
          this.is_loading = true
          await this.get_data()
          this.is_loading = false
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    download(){
      location.href = base_url+'/order/download?id='+this.$route.query.id
    },
  }
}
</script>
